// @flow

import { type Feature, type FeatureName } from './types';

export function getFeatureByName(allFeatures: ImmutableArray<Feature>, wanted: FeatureName): ?Feature {
  return allFeatures.find(feature => feature.name === wanted);
}

export function getSafeFeatureByName(allFeatures: ImmutableArray<Feature>, wanted: FeatureName): Feature {
  const feature = getFeatureByName(allFeatures, wanted);
  if (!feature)
    throw new Error(`getSafeFeatureByName - there is no feature "${wanted}" in all features`);
  return feature;
}
